import {
    apiRegister
} from '../../common/api';

import {
    isNumber,
    isArray,
    filter,
    map
} from '../../common/utils';
import { KGame } from '../../models/kgame';
import { ERR_REP_GAME_LIST, ERR_REQ_CUP_ID } from '../../common/const';

function checkResult({
    gameInfoList
}) {
    if (!isArray(gameInfoList)) {
        return ERR_REP_GAME_LIST // 数据格式非法
    }
    return 0
}

function formatResult({
    gameInfoList
}) {
    // 格式化
    gameInfoList = filter(gameInfoList, o => !!o && o.gameId > 0)
    gameInfoList = map(gameInfoList, g => KGame(g))
    return {
        gameInfoList
    }
}

/*
协议Id 
910
项目 
模块 
方式 
https 
命令（路径） 
/award/reality/gameinfos/
说明
获取本场gameList
请求参数
参数名称	参数类型	说明
cupId	int
*/

const gameInfos = apiRegister('game-infos', {
    protoId: 910,
    path: '/award/reality/gameinfos/',
    checkQuery(Q) {
        if (!isNumber(Q.cupId)) {
            return ERR_REQ_CUP_ID // 参数错误
        }
        return 0
    },
    checkResult,
    formatResult
})

// 接口
export const gamesLoad = gameInfos.send
